var megaMenu4i = function(){
	var mn = document.getElementsByClassName("main-nav")[0],
	header = document.querySelectorAll('header')[0],
	dropDown = document.getElementById('menuDropDown'),
	dropDownTrigger = document.getElementsByClassName("cd-dropdown-trigger")[0],
	dropDownClose = dropDown.querySelectorAll(".cd-close")[0],
	menuTrigger = document.getElementById("menuTrigger"),
	menuDropdown = document.getElementById("menuDropDown"),
	topMenu = document.getElementById("topOfMenu"),
	dropDownContent = document.getElementsByClassName('cd-dropdown-content')[0],
	mobileTrigger = document.getElementsByClassName("cd-dropdown-trigger-mobile")[0],
	secDropLi,
	goBackLinks,
	moveOut,
	isActive,
	hasChildren,
	hasChildrenUl;

    	var initMenuAim = function(){
	    	var megaMenu = new menuAim4i();
		var dropDownWrapper = document.getElementsByClassName("cd-dropdown-wrapper")[0];
		var submenuDirection = (!dropDownWrapper.classList.contains('open-to-left')) ? 'right' : 'left';
		var menuOptions = {
			activate: function(row) {
				var rowLink =  row.getElementsByTagName("a")[0];
				var rowUL = row.getElementsByClassName("cd-secondary-dropdown")[0];
				rowLink.classList.add("is-active");
				rowLink.setAttribute("aria-expanded", "true");
				rowUL.classList.add('is-active');
				rowUL.setAttribute('aria-hidden', 'false');
				rowUL.classList.remove('fade-out');
				
	    			if (dropDownContent.querySelectorAll("fade-in").length === 0) {
	    				rowUL.classList.add('fade-in');
	    			}
	    			
	    			var images = rowUL.querySelectorAll('img');
	    			for(var i = 0; i < images.length; i++){
	    				if (images[i].hasAttribute('data-lazy')) {
	            				var src = images[i].getAttribute('data-lazy');
	            				images[i].setAttribute('src', src);
	            				images[i].removeAttribute('data-lazy');
	        				}
	    			}
			},
			deactivate: function(row) {
				var rowLink =  row.getElementsByTagName("a")[0];
				var rowUL = row.getElementsByClassName("cd-secondary-dropdown")[0];
				rowLink.classList.remove("is-active");
				rowLink.setAttribute("aria-expanded", "false");
				rowUL.classList.remove('is-active');
				rowUL.setAttribute('aria-hidden', 'true');
		    		rowUL.classList.remove('fade-in');
	        		rowUL.classList.add('fade-out');
			},
			exitMenu: function(row) {
				if(row.classList.contains('is-active')){
					row.classList.remove('is-active');
		    			return true;
				}
			},
			submenuDirection: submenuDirection
		};
	    	megaMenu.init(menuOptions);
    	},
    	initMenuVars = function(){
		secDropLi = [].slice.call(document.getElementsByClassName("cd-secondary-dropdown")[0].querySelectorAll('li'));
		goBackLinks = [].slice.call(document.getElementsByClassName("go-back"));
		moveOut = document.querySelectorAll(".move-out");
		isActive = document.querySelectorAll(".is-active");
		hasChildren = [].slice.call(document.getElementsByClassName("has-children"));
		hasChildrenUl = document.querySelectorAll('.cd-secondary-dropdown');
    	},
    	hideStuff = function(){
    		dropDown.removeEventListener(whichAnimationEvent, hideStuff);
		hasChildrenUl.classList.add('is-hidden');
		moveOut.classList.remove('move-out');
              isActive.classList.remove('is-active');
		menuDropdown.setAttribute('aria-hidden', 'true');
	},
	whichAnimationEvent = function(){
		var t,
      		el = document.createElement("fakeelement");

 	 	var animations = {
    			"animation" : "animationend",
    			"OAnimation" : "oAnimationEnd",
    			"MozAnimation" : "animationend",
    			"WebkitAnimation" : "webkitAnimationEnd"
		};

		for (t in animations){
			if (el.style[t] !== undefined){
				return animations[t];
			}
		}
	},
	closeMenu = function(e){ // close menu on click outside of it - not working currently
		if((e.target !== dropDown) && (mobileTrigger.style.display === "none")){
			dropDown.classList.remove("dropdown-is-active");
        		menuDropdown.setAttribute('aria-hidden', 'true');
        		dropDownTrigger.classList.remove("dropdown-is-active");
        		dropDown.addEventListener(whichAnimationEvent, hideStuff);
		}
	},
	toggleMenu = function(e) {
		var navIsVisible = (!dropDown.classList.contains("dropdown-is-active")) ? true : false;
		dropDown.classList.toggle("dropdown-is-active", navIsVisible);
		dropDownTrigger.classList.toggle("dropdown-is-active", navIsVisible);
		menuDropdown.setAttribute('aria-hidden', 'false');
		dropDownTrigger.setAttribute("aria-expanded", "true");
		document.addEventListener('click', closeMenu); 
		
		if(!navIsVisible){
        		dropDown.addEventListener(whichAnimationEvent, hideStuff);
			document.removeEventListener('click', closeMenu); 
			menuDropdown.setAttribute('aria-hidden', 'true');
			dropDownTrigger.setAttribute("aria-expanded", "false");
		}
	},
	mobileGoBack = function(){
		var parent = this.parentNode;
		var parentTwo = parent.parentNode;
		var parentThree;
		if (parentTwo.parentNode.classList.contains("menuBranch")) {
			parentThree = parentTwo.parentNode.parentNode.parentNode;
		}
		else {
			parentThree = parentTwo.parentNode;
		}
		parent.classList.add('is-hidden');
		parentThree.classList.remove('move-out');
	},
	triggerMenu = function(e){
		e.stopImmediatePropagation();
        	e.stopPropagation();
        	e.preventDefault();
        	menuDropdown.classList.remove("hide");
        	setTimeout(function(){
        		toggleMenu(e);
        	}, 100);
        	return false;
	},
	triggerMenuClose = function(e){
		e.stopImmediatePropagation();
        	e.stopPropagation();
        	e.preventDefault();
        	toggleMenu(e);
        	return false;
	},
	scrollWindow = function(){
		if (window.scrollY > header.offsetHeight) {
			mn.classList.add("main-nav-scrolled");
		} else {
			mn.classList.remove("main-nav-scrolled");
		}
	},
	subLinkHidden = function(subLink){
		if (subLink.style.display === 'none') {
			subLink.setAttribute('aria-hidden', 'true');
		}
		else { subLink.setAttribute('aria-hidden', 'false'); }
	},
	isSubmenuInViewport = function(el) {
		//el = el[0];
		var rect = el.getBoundingClientRect();
	
		return (
			rect.top >= 0 && 
			rect.left >= 0 &&
			rect.left < (window.innerWidth || document.documentElement.clientWidth)
		);
	},
	menuEventListeners = function(){
		// on mobile - open submenu
		hasChildren.forEach(function(el, index, array){
			var childLink = el.getElementsByTagName("a")[0];
			childLink.addEventListener("click", function(e){
				var selectedParent = childLink.parentNode;
				var selectedSibling = childLink.nextElementSibling;
				if (!isSubmenuInViewport(selectedSibling)) {
					e.preventDefault();
					topMenu.scroll(0, 0);
					childLink.nextElementSibling.classList.remove('is-hidden');
					if (selectedParent.parentNode.classList.contains("menuBranch")) {
						selectedParent.parentNode.parentNode.parentNode.classList.add('move-out');
					}
					else {
						selectedParent.parentNode.classList.add('move-out');
					}
				}
			});
		});
	
	    	// if a sublink is hidden, make sure screen reader doesn't announce it as a number in the list
		secDropLi.forEach(function(el, index, array){
			subLinkHidden(el);
		});
		
		goBackLinks.forEach(function(el, index, array){
			el.addEventListener('click', mobileGoBack);
		});
		
		window.addEventListener("scroll", scrollWindow);
		menuTrigger.addEventListener('click', triggerMenu);
		dropDownClose.addEventListener('click', triggerMenuClose);
	},
	menuKeyEvents = function(){
		var activeMenuRow, activeMenuFlyout, firstMenuHead, lastMenuHead,
		menuDropDown = document.getElementsByClassName('cd-dropdown')[0],
		menuBarLinks = [].slice.call(document.getElementsByClassName('menuSubCategoriesMain')[0].getElementsByTagName("a")),
		menuBarLinkFirst = menuBarLinks[0],
		menuBarLinkLast = menuBarLinks[menuBarLinks.length-1],
		menuListItems = [].slice.call(topMenu.getElementsByClassName("menuRow")),
		dropDownFirstLink = menuListItems[0].getElementsByTagName("a")[0],
		dropDownLastLink = document.getElementById('seeMoreMenuLink');
		
		// check if element is visible
		function visible(el) {
			return el.offsetWidth > 0 || el.offsetHeight > 0;
		}
		// close menu
		function resetMenu(row, flyout){
			row.getElementsByTagName("a")[0].classList.remove('is-active');  // does not like this if hitting up arrow on the first header
			row.getElementsByTagName("a")[0].focus();
			flyout.classList.remove('is-active');
			flyout.setAttribute('aria-hidden', 'true');
		}
		// for keydown events
		function preventionKeys(e){
			e.preventDefault();
			e.stopPropagation();
		}

		/* horizontal menu bar links */
		menuBarLinks.forEach(function(el, index, array) {
			el.addEventListener("keydown", function(e){
				var nextLink = array[index + 1];
				var prevLink = array[index - 1];
				if ([37,39].indexOf(e.which) == -1) { return; } // if not right, left keys end here
				switch(e.which) {
					case 37: // left arrow
						preventionKeys(e);
						if(menuBarLinkFirst == document.activeElement){
							dropDownTrigger.focus();
						} else {
							prevLink.focus();
						}
						break;
					case 39: // right arrow
						preventionKeys(e);
						if(menuBarLinkLast == document.activeElement){
							dropDownTrigger.focus();
						} else {
							nextLink.focus();
						}
				}
			});
		});

		dropDownTrigger.addEventListener("keydown", function(e){
			if ([32, 37, 39, 40].indexOf(e.which) == -1) { return; } // if not up, down, left and right keys end here
			switch(e.which) {
				case 37: // left arrow
					preventionKeys(e);
					menuBarLinkLast.focus();
					menuDropDown.classList.remove('dropdown-is-active');
					dropDownTrigger.classList.remove('dropdown-is-active');
					break;
				case 39: // right arrow
					preventionKeys(e);
					menuBarLinkFirst.focus();
					menuDropDown.classList.remove('dropdown-is-active');
					dropDownTrigger.classList.remove('dropdown-is-active');
					break;
				case 32: // space bar
				case 40: // down arrow
					preventionKeys(e);
					menuDropDown.classList.add('dropdown-is-active');
					dropDownTrigger.classList.add('dropdown-is-active');		
					// give animation time to run
					setTimeout(function() { dropDownFirstLink.focus(); }, 200);
					
			}
		});

		document.addEventListener("keydown", function(e){
			if(e.keyCode == 27 && menuDropDown.classList.contains('dropdown-is-active')){ //esc
				menuDropDown.classList.remove('dropdown-is-active');
				dropDownTrigger.classList.remove('dropdown-is-active');
				dropDownTrigger.focus();
			}
		});
		
		/*menuListItems = ".menuRow"
		** the list of categories in the initial drop down
		*/
		menuListItems.forEach(function(el, index, array) {
			var menuListLink = el.getElementsByTagName("a")[0];
			var nextList = array[index + 1];
			var prevList = array[index - 1];
			var allMenuFlyOuts = document.getElementsByClassName("cd-secondary-dropdown");
			var allVisibleLinks = [];
			
		 	menuListLink.addEventListener("keydown", function(e){
				if ([38, 39, 40].indexOf(e.which) == -1) { return; } // if not up, down and right keys end here
				switch(e.which) {
					case 38: // up arrow
						preventionKeys(e);
						if(dropDownFirstLink == document.activeElement){
							dropDownTrigger.focus();
						} else {
							prevList.getElementsByTagName("a")[0].focus();
						}
						break;
					case 39: // right arrow
						preventionKeys(e);
						var menuFlyOut = menuListLink.parentNode.getElementsByClassName("cd-secondary-dropdown")[0];
						for(var i = 0; i < allMenuFlyOuts.length; i++){
							allMenuFlyOuts[i].classList.remove("is-active");
							allMenuFlyOuts[i].setAttribute('aria-hidden', 'true');
						}
						activeMenuRow = el;
						activeMenuFlyout = menuFlyOut;
	
						// INIT THE ACTIVE MENU FLYOUT
						menuFlyOut.classList.add('is-active');
						menuFlyOut.setAttribute('aria-hidden', 'false');
						menuListLink.classList.add('is-active');
						
						var allLinks = menuFlyOut.getElementsByTagName("li");
						for(i = 0; i < allLinks.length; i++){
							var isVisible = visible(allLinks[i]);
							if(isVisible){ // if true
							 	allVisibleLinks.push(allLinks[i]);
							}
						}
						// focus on the first visible link in the flyout
						allVisibleLinks[0].getElementsByTagName("a")[0].focus();
						getVisibleMenuLinks(allVisibleLinks); 
						break;
					case 40: // down arrow
						preventionKeys(e);
						if(dropDownLastLink == document.activeElement){
							dropDownTrigger.focus();
						} else {
							nextList.getElementsByTagName("a")[0].focus();
						}
				}
				if(e.altKey){ // alt + down arrow to open the menu (native control for accessing content via keyboard)
					switch(e.which){
						case 40:
							preventionKeys(e);
							var menuFlyOut = menuListLink.parentNode.getElementsByClassName("cd-secondary-dropdown")[0];
							for(var i = 0; i < allMenuFlyOuts.length; i++){
								allMenuFlyOuts[i].classList.remove("is-active");
								allMenuFlyOuts[i].setAttribute('aria-hidden', 'true');
							}
							activeMenuRow = el;
							activeMenuFlyout = menuFlyOut;
		
							// INIT THE ACTIVE MENU FLYOUT
							menuFlyOut.classList.add('is-active');
							menuFlyOut.setAttribute('aria-hidden', 'false');
							menuListLink.classList.add('is-active');
							
							var allLinks = menuFlyOut.getElementsByTagName("li");
							for(i = 0; i < allLinks.length; i++){
								var isVisible = visible(allLinks[i]);
								if(isVisible){ // if true
								 	allVisibleLinks.push(allLinks[i]);
								}
							}
							// focus on the first visible link in the flyout
							allVisibleLinks[0].getElementsByTagName("a")[0].focus();
							getVisibleMenuLinks(allVisibleLinks); 
							break;
					}
				}
		 	});
		});

		function getVisibleMenuLinks(link){
			var headLinks = [];
			var menuAdverts = [];
			
			// break down into new arrays - one for the main link head one for the menu adverts
			link.forEach(function(el, index, array) {
				if(el.classList.contains("subCatHead")){
					headLinks.push(el);
				} else if(el.classList.contains("menuAdvert")){
					menuAdverts.push(el);
				}
			});
			
			firstMenuHead = headLinks[0].getElementsByTagName("a")[0];
			lastMenuHead = headLinks[headLinks.length - 1].getElementsByTagName("a")[0];
	
			headLinks.forEach(function(el, index, array) {
				var nextHeadLink = array[index + 1] ? array[index + 1].getElementsByTagName("a")[0] : "";
				var prevHeadLink = array[index - 1] ? array[index - 1].getElementsByTagName("a")[0] : "";
				var subLinkArray = [];
				
				// push visible sublinks into a new array to access later
				if(el.classList.contains("has-children")){
					var sublinks = el.getElementsByClassName("subCategories")[0].getElementsByTagName("li");
					for(var i = 0; i < sublinks.length; i++){
						var isVisible = visible(sublinks[i]);
						if(isVisible){ // if true
							subLinkArray.push(sublinks[i]);
						}
					}
					getVisibleSubLinks(subLinkArray);
				} 
				el.addEventListener("keydown", function(e){
					if ([37, 38, 39, 40].indexOf(e.which) == -1) { return; } // if not up, down, left and right keys end here
					switch(e.which) {
						case 37: // left arrow
						case 38: // up arrow
							preventionKeys(e);
							if(prevHeadLink !== ""){
								prevHeadLink.focus();
							}else {
								resetMenu(el.parentNode.parentNode.parentNode.parentNode, el.parentNode.parentNode.parentNode);
							}
							break;
						case 39: // right arrow
							preventionKeys(e);
							var flyOutAdverts = activeMenuFlyout.getElementsByClassName('productAdverts')[0] ? activeMenuFlyout.getElementsByClassName('productAdverts')[0] : "";
								
							if(nextHeadLink !== ""){
								nextHeadLink.focus();
							}else if(flyOutAdverts !== ""){
								flyOutAdverts.getElementsByTagName("a")[0].focus();
							}else {
								firstMenuHead.focus();
							}
							break;
						case 40: // down arrow
							preventionKeys(e);
							if(el.classList.contains("has-children")){ 
								subLinkArray[0].getElementsByTagName("a")[0].focus();
							} else if(nextHeadLink !== ""){
								nextHeadLink.focus();  
							} else{
								resetMenu(el.parentNode.parentNode.parentNode.parentNode, el.parentNode.parentNode.parentNode);
							}
						}
				});
			});

			menuAdverts.forEach(function(el, index, array) {
				var menuAdvertLink = el.getElementsByTagName("a")[0];
				var lastAdvert = array[array.length -1].getElementsByTagName("a")[0];
				var nextAdvertLink = array[index + 1] ? array[index + 1].getElementsByTagName("a")[0] : "";
				var prevAdvertLink = array[index - 1] ? array[index - 1].getElementsByTagName("a")[0] : "";
				
				menuAdvertLink.addEventListener("keydown", function(e){
					if ([37, 38, 39,40].indexOf(e.which) == -1) { return; } // if not up, down, left and right keys end here
					switch(e.which) {
						case 37: // left arrow
						case 38: // up arrow 
							preventionKeys(e);
							if(prevAdvertLink !== ""){
								prevAdvertLink.focus();
							} else {
								lastMenuHead.focus();
							}
							break;
						case 39: // right arrow
							preventionKeys(e);
							if(nextAdvertLink !== ""){
								nextAdvertLink.focus(); 
							}else {
								firstMenuHead.focus(); 
							}
							break;
						case 40: // down arrow
							preventionKeys(e);
							if(nextAdvertLink !== ""){
								nextAdvertLink.focus(); 
							}else {
								resetMenu(lastAdvert.parentNode.parentNode.parentNode.parentNode.parentNode, lastAdvert.parentNode.parentNode.parentNode.parentNode);
							}
					}
				});
			});
		}
		
		// subLinkArray = all <li> elements under the header links
		function getVisibleSubLinks(links){
			links.forEach(function(el, index, array) {
				var subCatLink = el.getElementsByTagName("a")[0];
				var firstSubLink = array[0].getElementsByTagName("a")[0];
				var nextSubLink = array[index + 1] ? array[index + 1].getElementsByTagName("a")[0] : "";
				var prevSubLink = array[index - 1] ? array[index - 1].getElementsByTagName("a")[0] : "";

				var prevHeader = el.parentNode.parentNode.previousElementSibling ? el.parentNode.parentNode.previousElementSibling.getElementsByTagName("a")[0] : "";
				var nextHeader = el.parentNode.parentNode.nextElementSibling ? el.parentNode.parentNode.nextElementSibling.getElementsByTagName("a")[0] : "";
				
				subCatLink.addEventListener("keydown", function(e){
					if ([37, 38, 39, 40].indexOf(e.which) == -1) { return; } // if not up, down, left and right keys end here
					switch(e.which) {
						case 37: // left arrow
							preventionKeys(e);
							// go into the previous column
							if(prevHeader == "" && el.parentNode.parentNode.parentNode.previousElementSibling){
								el.parentNode.parentNode.parentNode.previousElementSibling.getElementsByTagName("li")[0].getElementsByTagName("a")[0].focus();
							}else if(prevHeader !== ""){ // else previous header
								prevHeader.focus();
							}else{ // else close the menu
								resetMenu(el.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode, el.parentNode.parentNode.parentNode.parentNode.parentNode);
							}
							break;
						case 38: // up arrow
							preventionKeys(e);
							if(prevSubLink !== ""){
								prevSubLink.focus();
							}else{
								firstSubLink.parentNode.parentNode.previousElementSibling.focus();
							}
							break;
						case 39: // right arrow
							preventionKeys(e);
							//go into the next column
							if(nextHeader !== ""){
								nextHeader.focus();
							}else if(nextHeader == "" && el.parentNode.parentNode.parentNode.nextElementSibling){
								el.parentNode.parentNode.parentNode.nextElementSibling.getElementsByTagName("li")[0].getElementsByTagName("a")[0].focus();
							}else{ // else go to first menu advert
								el.parentNode.parentNode.parentNode.parentNode.nextElementSibling.getElementsByTagName("a")[0].focus();
							}
							break;
						case 40: // down arrow
							preventionKeys(e);
							if(nextSubLink !== ""){
								nextSubLink.focus();
							}else if(nextHeader !== ""){
								nextHeader.focus();
							}else if(nextHeader == "" && el.parentNode.parentNode.parentNode.nextElementSibling){
								el.parentNode.parentNode.parentNode.nextElementSibling.getElementsByTagName("li")[0].getElementsByTagName("a")[0].focus();
							}else{
								//last menu link
								el.parentNode.parentNode.parentNode.parentNode.nextElementSibling.getElementsByClassName("menuAdvert")[0].getElementsByTagName("a")[0].focus();
							}
					}
				});
			});
		}

	},
	
	init = function(){
		// hiding so the links are not overlapping content
		// hide is removed when the trigger is clicked
		menuDropdown.classList.add("hide"); 
		
		// defer loading the menu content
    		var menuContentRequest = ajax({
			method: "GET",
			url: '/header/megamenu2019',
			timeout: 20000
		});
		menuContentRequest.then(function(response, xhr){
			// success, do something
			topMenu.innerHTML = response;
			initMenuVars(); // initialize variables which depend upon the menu content
			initMenuAim();
			menuEventListeners();
			menuKeyEvents();
		});	
	};
	
	return{
		init: init
	};
};